export default {"src":"/_next/static/media/4.f08e6297.svg","height":140,"width":124,"blurWidth":0,"blurHeight":0};